import React from 'react';

export type AvatarProps = React.HTMLAttributes<HTMLDivElement> & {
  initials?: string;
  size?: number;
};

export const Avatar: React.FC<AvatarProps> = ({
  initials,
  size,
  className = '',
  style,
  children,
  ...rest
}) => {
  const sizeStyle = size ? { width: size, height: size, fontSize: Math.max(11, size * 0.4) } : {};
  return (
    <div className={`avatar ${className}`} style={{ ...sizeStyle, ...style }} {...rest}>
      {children ?? initials}
    </div>
  );
};
